let maskGenerationFunction = [
  'MGF1'
]

export default maskGenerationFunction
